import { render } from "./ImagePicker.vue?vue&type=template&id=391c094a&scoped=true&ts=true"
import script from "./ImagePicker.vue?vue&type=script&lang=ts"
export * from "./ImagePicker.vue?vue&type=script&lang=ts"

import "./ImagePicker.vue?vue&type=style&index=0&id=391c094a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\nyffeler\\IdeaProjects\\data_tools\\Branches\\data_tools\\131\\frontend-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-391c094a"]])

export default __exports__